import GetWorkItemStatusesRequestModelBase from '../_generated/modelBases/get-work-item-statuses-request-model-base';

export default class GetWorkItemStatusesRequestModel extends GetWorkItemStatusesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
